module.exports = __webpack_public_path__ + "static/media/60.543d9f92.gif";